import { alias, API_URL, ROLE } from "../../helpers/utils";
import axios from "../../helpers/axios";
import { catchHandler, dispatchError, dispatchLoading, dispatchToast, elseHandler } from "../../helpers/dispatch";
import { decryptByText, responseDataFormate } from "../../helpers/bycrypt";
import { StaticResponse } from "../Types/response/static.interface";

type DispatchAction = (action: { type: string; payload: { scope: string; status?: boolean | string | string[] } }) => void;

type NavigateFunction = (path: string) => void;

const staticPageUrl = `${API_URL}/staticPage`;

export const FetchStaticPage =
	(page: number, limit = 10, search: string | null, id: string | null, setIsLoading: (loading: boolean) => void) =>
	async (dispatch: (action: any) => void): Promise<void> => {
		dispatchLoading(dispatch, "static", true);
		setIsLoading(true);

		setIsLoading(true);
		axios
			.get(
				`${staticPageUrl}/static`,

				{
					params: {
						page,
						limit,
						search,
						id,
					},
					// headers: { "Api-Key": API_KEY },
					withCredentials: true,
				}
			)
			.then((response) => {
				let result: StaticResponse = responseDataFormate(response.data);

				if (result?.success) {
					setIsLoading(false);
					dispatch({ type: "STATIC_PAGE_LIST_SUCCESS", payload: { list: result?.data?.data, count: result?.data?.count } });
					dispatchError(dispatch, "static", undefined);
				} else elseHandler(dispatch, "static", result);
				dispatchLoading(dispatch, "static", false);
			})
			.catch((e) => {
				setIsLoading(false);
				catchHandler(dispatch, "static")(e);
			});
	};

export const FetchStaticPageByID =
	(id: string | undefined, setIsLoading: (loading: boolean) => void) =>
	async (dispatch: (action: any) => void): Promise<void> => {
		dispatchLoading(dispatch, "static", true);
		axios
			.get(
				`${staticPageUrl}/static`,

				{ params: { id }, withCredentials: true }
			)
			.then((response) => {
				let result: StaticResponse = responseDataFormate(response.data);
				if (result?.success) {
					dispatch({ type: "STATIC_PAGE_DETAILS_SUCCESS", payload: result?.data?.data?.find((ele, i) => ele?._id === id) });
					dispatchError(dispatch, "static", undefined);
				} else elseHandler(dispatch, "static", result);
				dispatchLoading(dispatch, "static", false);
			})
			.catch(catchHandler(dispatch, "static"));
	};

export const UpdateStaticPage =
	(staticPageId: string, updates: any, navigate: NavigateFunction, setIsLoading: (loading: boolean) => void) =>
	async (dispatch: (action: any) => void): Promise<void> => {
		dispatchLoading(dispatch, "static", true);
		axios
			.put(`${staticPageUrl}/static`, { staticPageId, updates }, { withCredentials: true })
			.then((response) => {
				let result = responseDataFormate(response.data);
				if (result?.success) {
					dispatchToast(dispatch, "success", result?.message);
					navigate("/admin/static-pages");
					dispatchError(dispatch, "static", undefined);
				} else elseHandler(dispatch, "static", result);
				dispatchLoading(dispatch, "static", false);
			})
			.catch(catchHandler(dispatch, "static"));
	};

export const FetchStaticPageByURL =
	(url: string, setIsLoading: (loading: boolean) => void) =>
	async (dispatch: (action: any) => void): Promise<void> => {
		dispatchLoading(dispatch, "staticPage", true);
		if (url) {
			axios
				.get(`${staticPageUrl}/static/single?url=${url}`, {
					withCredentials: true,
				})
				.then((response) => {
					let result = responseDataFormate(response.data);
					if (result?.success) {
						dispatch({ type: "SINGLE_STATIC_PAGE_SUCCESS", payload: result?.data });
						dispatchError(dispatch, "staticPage", undefined);
					} else elseHandler(dispatch, "staticPage", result);
					dispatchLoading(dispatch, "staticPage", false);
				})
				.catch(catchHandler(dispatch, "staticPage"));
		}
	};
